const panelToggle = function (): void {
    const panelTriggers = document.querySelectorAll<HTMLElement>('.panel-trigger');
    const firstItemActives = document.querySelectorAll<HTMLElement>('.panel-expandable--first-active');

    if (firstItemActives.length > 0) {
        firstItemActives.forEach((item) => {
            const trigger = item.querySelector<HTMLElement>('.panel-trigger');
            const content = item.querySelector<HTMLElement>('.panel-content');
            trigger?.setAttribute('aria-expanded', 'true');
            trigger?.classList.add('active');
            content?.classList.add('active');
        });
    }

    panelTriggers.forEach((trigger) => {
        trigger.addEventListener('click', function (evt) {
            if (!( evt.target as HTMLElement).closest('.panel-expandable--first-active')) {
                if (trigger.classList.contains('active')) {
                    trigger.classList.toggle('active');
                    const targetId = trigger.dataset.toggle as string;
                    document.getElementById(targetId)?.classList.toggle('active');
                } else {
                    trigger.classList.add('active');
                    const targetId = trigger.dataset.toggle as string;
                    document.getElementById(targetId)?.classList.add('active');
                }
            } else {
                trigger
                    .closest('.panel-group')
                    ?.querySelectorAll<HTMLElement>('.panel-trigger, .panel-content')
                    .forEach((item) => {
                        item.classList.remove('active');
                    });
                trigger.classList.add('active');
                const targetId = trigger.dataset.toggle as string;
                document.getElementById(targetId)?.classList.add('active');
            }

            const ariaxpd = trigger.getAttribute('aria-expanded');
            trigger.setAttribute('aria-expanded', ariaxpd === 'true' ? 'false' : 'true');
        });
    });
};

panelToggle();
